import { useMemo } from 'react';
import {
  Box,
  Button,
  CircularProgress,
  Menu,
  MenuItem,
  TextField,
} from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

import { AdminRoles, Role } from '../../config/DiactiveTypes';
import CircularProgressWithLabel from '../common/CircularProgressWithLabel';
import {
  exportMultiUsersFile,
  exportMultiWorkoutsFile,
  exportQuestionnairesFile,
  exportSingleUsersZip,
} from '../../managers/ExcelExporter';

const PatientsTableToolbar = ({
  role,
  searchQuery,
  onSearchChange,
  downloadingMulti,
  anchorEl,
  onMenuOpen,
  onMenuClose,
  onExportAction,
  downloadProgressValue,
  downloadProgressString,
}) => {
  const showSearch = role === Role.Doctor;

  const exportMenuItems = useMemo(() => {
    const items = [
      { label: 'Excel de Participantes', exportFn: exportMultiUsersFile },
      { label: 'Excel de Sesiones', exportFn: exportMultiWorkoutsFile },
    ];

    if (AdminRoles.includes(role)) {
      items.push({ label: 'Excel de Cuestionarios', exportFn: exportQuestionnairesFile });
    }

    items.push({ label: 'ZIP de Participantes', exportFn: exportSingleUsersZip });
    return items;
  }, [role]);

  return (
    <Box
      sx={{
        display: { xs: 'block', sm: 'flex' },
        justifyContent: showSearch ? 'space-between' : 'flex-end',
        alignItems: 'center',
      }}
    >
      {showSearch && (
        <TextField
          label="Buscar"
          variant="outlined"
          value={searchQuery}
          onChange={onSearchChange}
          margin="normal"
          sx={{ width: { xs: '100%', sm: 300 } }}
        />
      )}

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          mt: { xs: 1, sm: 0 },
          alignItems: 'center',
        }}
      >
        <Button
          variant="contained"
          endIcon={downloadingMulti ? <CircularProgress size={20} /> : <ExpandMore />}
          onClick={onMenuOpen}
          aria-label="export-options"
          sx={{ height: 50 }}
          disabled={downloadingMulti}
        >
          {downloadingMulti ? 'Exportando...' : 'Exportar Datos'}
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={onMenuClose}
          sx={{ mt: 1 }}
        >
          {exportMenuItems.map((item) => (
            <MenuItem key={item.label} onClick={() => onExportAction(item.exportFn)}>
              {item.label}
            </MenuItem>
          ))}
        </Menu>

        {downloadingMulti && (
          <CircularProgressWithLabel size={50} value={downloadProgressValue} string={downloadProgressString} />
        )}
      </Box>
    </Box>
  );
};

export default PatientsTableToolbar;

